import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";

export default function Permanent() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Permanent Hiring"
          subtitle={
  <div>
    <p>
      Our permanent hiring solutions help businesses build strong, long-term teams 
      by connecting them with top talent that aligns with their goals. Here’s why 
      we’re the right choice for your hiring needs:
    </p>
    {!state.auth.isMobile ? (
      <ul>
        <li>
          <strong>Quality Talent Acquisition</strong>: We source, screen, and 
          deliver highly skilled professionals who fit your company culture and 
          long-term vision.
        </li>
        <li>
          <strong>Industry-Specific Expertise</strong>: Our hiring specialists 
          understand diverse industries, ensuring the right match for your 
          business needs.
        </li>
        <li>
          <strong>Seamless Recruitment Process</strong>: From initial sourcing to 
          final onboarding, we handle the entire hiring journey efficiently, 
          reducing time-to-hire.
        </li>
      </ul>
    ) : (
      ""
    )}
    <p>
      Partner with us to secure top-tier talent and build a dedicated, high-performing team for long-term success.
    </p>
  </div>
}

        />

        <ContentSideBySideInv
          title="Pemanent Hiring Benefits"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              {/* Better Decision-Making Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                    Stable & Reliable Workforce
                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
            Permanent employees provide long-term stability, fostering loyalty and organizational growth.
            </div>
                </div>
              </div>

              {/* Accuracy Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                  Cost-Effective Recruitment
                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
            Reduces the need for frequent hiring, lowering overall recruitment and training expenses.
            </div>
                </div>
              </div>

              {/* Process Optimization Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                     Higher Employee Engagement & Retention

                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
            Investing in permanent hires enhances job satisfaction, leading to increased productivity and long-term retention.
            </div>
                </div>
              </div>
            </div>
          }
          image={
            <img
              style={{ width: "100%", marginTop: "15px" }}
              src={require("../img/33.jpg")}
            />
          }
        />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <FeatureCard
              minHeight={"45vh"}
              title={"Research"}
              text={`In the Research phase, our approach is driven by data that
                echoes the user’s voice while aligning perfectly with your
                business objectives. This helps you to set the design patterns
                intuitively and clearly.`}
              icon={
                <TravelExploreIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle2={
            <FeatureCard
              minHeight={"45vh"}
              title={"Design"}
              text={`During the designing phase, our team of UX-UI experts dedicates
                itself to creating designs that are not only loved by users for
                their intuitiveness but are also scalable to meet growing
                demands and industry standards.`}
              icon={
                <DvrIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle3={
            <FeatureCard
              minHeight={"45vh"}
              title={"Build"}
              text={`In this phase, we transform designs into pixel-perfect,
                adaptable, and scalable products. Whether it’s a startup idea or
                an enterprise project, our technical prowess ensures that your
                vision is translated into reality.`}
              icon={
                <WindowIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
        />
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
